import React from 'react';
import { Link } from 'react-router-dom';

const TestNavigation = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Test Navigation</h1>
      <div className="space-y-2">
        <div>
          <Link to="/timesheet-with-sidebar" className="text-blue-600 hover:underline">
            Go to Timesheet with User Sidebar
          </Link>
        </div>
        <div>
          <Link to="/m-timesheet" className="text-blue-600 hover:underline">
            Go to Mobile Timesheet View
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TestNavigation;
